import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= RAJASTHAN CITY DATA ================= */

const rajasthanCities = [
  { slug: "jaipur", city: "Jaipur", state: "Rajasthan" },
  { slug: "jodhpur", city: "Jodhpur", state: "Rajasthan" },
  { slug: "udaipur", city: "Udaipur", state: "Rajasthan" },
  { slug: "kota", city: "Kota", state: "Rajasthan" },
  { slug: "ajmer", city: "Ajmer", state: "Rajasthan" }
];

const Rajasthan = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <>
        <Helmet>
          <title>
            Sex Toys Delivery in Rajasthan | Discreet Adult Store Online
          </title>
          <meta
            name="description"
            content="Buy sex toys online in Rajasthan with 100% discreet delivery. Trusted adult store delivering to Jaipur, Jodhpur, Udaipur, Kota, Ajmer & more."
          />
          <link
            rel="canonical"
            href="https://lushdesire.in/sex-toys-delivery/rajasthan"
          />
        </Helmet>

        <div
          style={{
            marginTop: "90px",
            padding: "25px",
            backgroundColor: "#FFF5F5",
            minHeight: "90vh",
            lineHeight: "1.8"
          }}
        >
          <h1>Sex Toys Delivery in Rajasthan</h1>

          <p>
            Buy premium <strong>sex toys in Rajasthan</strong> with fast,
            safe, and <strong>100% discreet delivery</strong>. LushDesire is a
            trusted Indian adult wellness store offering body-safe pleasure
            products for men, women, and couples across Rajasthan.
          </p>

          <h2>Cities We Serve in Rajasthan</h2>

          <ul>
            {rajasthanCities.map((c) => (
              <li key={c.slug}>
                <Link to={`/sex-toys-delivery/rajasthan/${c.slug}`}>
                  Sex Toys in {c.city}
                </Link>
              </li>
            ))}
          </ul>

          <h3>Why Buy Sex Toys Online from LushDesire?</h3>
          <ul>
            <li>✔ Original & body-safe products</li>
            <li>✔ Plain, discreet packaging</li>
            <li>✔ Cash on Delivery available</li>
            <li>✔ Fast delivery across Rajasthan</li>
          </ul>

          <p>
            Order online today and enjoy private, secure shopping from
            Rajasthan’s trusted adult toy store.
          </p>
        </div>
      </>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = rajasthanCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Rajasthan
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys and couples wellness products available in ${cityData.city}, Rajasthan.`}
        />
        <link
          rel="canonical"
          href={`https://lushdesire.in/sex-toys-delivery/rajasthan/${cityData.slug}`}
        />
      </Helmet>
      <CategorySlider />


      <div
        style={{
    
          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.8"
        }}
      >
        <h1>Sex Toys in {cityData.city} – Discreet Home Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium adult wellness products with complete privacy and fast
          delivery across {cityData.city} and nearby areas.
        </p>

        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Shopping online for sex toys in {cityData.city} is now safe and
          comfortable. Our curated collection includes pleasure products
          designed to enhance intimacy, confidence, and wellness.
        </p>

        <h3>Popular Adult Toys Available</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Intimacy Products</li>
          <li>✔ Male & Female Wellness Toys</li>
        </ul>

        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet Packaging</li>
          <li>✔ Fast Local Delivery</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        <h4>Discreet Sex Toys Delivery in {cityData.city}</h4>
        <p>
          Every order is shipped in plain packaging with no adult branding.
          Your privacy is fully protected from checkout to delivery.
        </p>

        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Place your order today and enjoy premium adult wellness products with
          fast delivery, secure payments, and complete peace of mind.
        </p>

        <p>
          <strong>LushDesire</strong> – India’s trusted online sex toy store.
        </p>
      </div>
    </>
  );
};

export default Rajasthan;
